import { render } from "./Bins.vue?vue&type=template&id=b92fc334&scoped=true&ts=true"
import script from "./Bins.vue?vue&type=script&lang=ts"
export * from "./Bins.vue?vue&type=script&lang=ts"

import "./Bins.vue?vue&type=style&index=0&id=b92fc334&scoped=true&lang=css"

import exportComponent from "E:\\trackzone\\Admin_panel\\admin panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b92fc334"]])

export default __exports__